/* ============================================================
   Exclusive Smokes Refresh - Joy Loyalty runtime overrides
   Created 2026-06-20.

   Two jobs:
     (A) Reposition the floating Rewards launcher to bottom-LEFT
         after Joy mounts it (Material-UI inline styles win over
         CSS unless we patch them directly).
     (B) Suppress Joy AUTO-opened popups (Welcome / Membership /
         Hello 618 POINTS tooltip) without breaking the panel
         that opens when the customer clicks the launcher.

   Strategy for (B):
     - Track when the user clicks the launcher (or any rewards
       link). Set a userInitiated flag for 8s.
     - MutationObserver watches the whole document.
     - If Joy injects content into #Avada-Joy-modal while
       userInitiated is FALSE, treat as auto-open and remove it.
     - If userInitiated is TRUE, leave it alone.
     - Also kill any classed welcome/membership popups that appear
       outside the modal regardless of the flag.
   ============================================================ */
(function () {
  'use strict';

  var LAUNCHER_SEL = '#Avada-Joy_FloatingButton';
  var MODAL_SEL    = '#Avada-Joy-modal';
  var REWARDS_LINK_SEL = 'a[href*="/pages/rewards"], a[href$="/rewards"]';

  var ALWAYS_KILL_SEL = [
    '.Avada-Joy_WelcomePopup',
    '.Avada_Joy-WelcomePopup',
    '.Avada_Joy_WelcomePopup',
    '[class*="WelcomePopup"][class*="Avada"]',
    '[class*="WelcomePopup"][class*="Joy"]',
    '[class*="Avada-Joy_Welcome"]',
    '[class*="Avada_Joy-Welcome"]',
    '.Avada-Joy_MembershipPopup',
    '.Avada_Joy-MembershipPopup',
    '.Avada_Joy_MembershipPopup',
    '[class*="MembershipPopup"][class*="Avada"]',
    '[class*="MembershipPopup"][class*="Joy"]',
    '[class*="Avada-Joy_Membership"]',
    '[class*="Avada_Joy-Membership"]',
    '[class*="PointsPopup"][class*="Joy"]',
    '[class*="RedeemPopup"][class*="Joy"]',
    '[class*="PointsBubble"][class*="Joy"]',
    '[class*="LoyaltyTooltip"][class*="Joy"]',
    '[data-joy-popup="welcome"]',
    '[data-joy-popup="membership"]',
    '[data-joy-popup="redeem"]',
    '[data-avada-joy-popup]',
    '#Avada-Joy_WelcomePopup',
    '#Avada-Joy_MembershipPopup',
    '#Avada-Joy_RedeemPopup',
    '#Avada-Joy_PointsBubble'
  ].join(',');

  function repositionLauncher() {
    var root = document.querySelector(LAUNCHER_SEL);
    if (!root) return false;
    var positioned = root.querySelectorAll('div');
    var moved = false;
    for (var i = 0; i < positioned.length; i++) {
      var el = positioned[i];
      var cs = window.getComputedStyle(el);
      if (cs && cs.position === 'fixed' && el.offsetWidth > 0 && el.offsetHeight > 0) {
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        el.style.setProperty('right', 'auto', 'important');
        el.style.setProperty('left', isMobile ? '16px' : '20px', 'important');
        el.style.setProperty('bottom', isMobile
          ? 'max(20px, env(safe-area-inset-bottom))'
          : '24px', 'important');
        el.style.setProperty('z-index', '35', 'important');
        moved = true;
      }
    }
    return moved;
  }

  var userInitiated = false;
  var userInitiatedUntil = 0;
  function setUserInitiated() {
    userInitiated = true;
    userInitiatedUntil = Date.now() + 8000;
  }
  function isUserInitiated() {
    if (Date.now() > userInitiatedUntil) userInitiated = false;
    return userInitiated;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(LAUNCHER_SEL) || t.closest(REWARDS_LINK_SEL)) {
      setUserInitiated();
    }
  }, true);

  function killAlwaysAutoPopups() {
    try {
      var nodes = document.querySelectorAll(ALWAYS_KILL_SEL);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.closest && (n.closest('.Avada_Joy-LoyaltyWallet') ||
                          n.closest('#joy-pass-wallet'))) continue;
        n.style.setProperty('display', 'none', 'important');
        n.style.setProperty('visibility', 'hidden', 'important');
        n.style.setProperty('pointer-events', 'none', 'important');
        if (n.parentNode) {
          try { n.parentNode.removeChild(n); } catch (err) {}
        }
      }
    } catch (e) {}
  }

  function clearAutoModal() {
    var m = document.querySelector(MODAL_SEL);
    if (!m) return;
    if (m.children.length === 0) return;
    if (isUserInitiated()) return;
    try {
      m.innerHTML = '';
      if (document.body && document.body.style.overflow === 'hidden') {
        document.body.style.removeProperty('overflow');
      }
      document.body.classList.remove('joy-modal-open', 'avada-joy-modal-open');
    } catch (e) {}
  }

  function sweep() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/pages/rewards') {
      killAlwaysAutoPopups();
      clearAutoModal();
    }
    repositionLauncher();
  }

  sweep();
  var fastTicks = 0;
  var fastSweep = setInterval(function () {
    sweep();
    fastTicks++;
    if (fastTicks > 40) clearInterval(fastSweep);
  }, 250);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { sweep(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('resize', repositionLauncher, { passive: true });
  window.addEventListener('orientationchange', repositionLauncher, { passive: true });
})();

